// @flow
import styles from './SearchResultList.less';

import React, { Component } from 'react';
import classnames from 'classnames';

import JobListItem from './JobListItem/JobListItem';
import Nudge from './Nudge/Nudge';

import { isEqual, findIndex } from 'lodash';

const idLens = job => job.id;

type Props = {
  jobs: Array<SearchResultJob>,
  showNudge?: boolean
};

type ListDetails = {
  isFirstJobClassic: boolean,
  isLastJobClassic: boolean
};

const getListDetails = (jobs: Array<SearchResultJob>): ListDetails => {
  const firstJob = jobs[0];
  const lastJob = jobs[jobs.length - 1];

  return {
    isFirstJobClassic: !firstJob.isStandOut && !firstJob.isPremium,
    isLastJobClassic: !lastJob.isStandOut && !lastJob.isPremium
  };
};

const getIndexOfFirstNonPremium = (jobs: Array<SearchResultJob>): number => {
  return findIndex(jobs, ['isPremium', false]);
};

class SearchResultList extends Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    const { jobs: nextJobs, showNudge: nextShowNudge } = nextProps;
    const { jobs: prevJobs, showNudge: prevShowNudge } = this.props;
    const nextIds = nextJobs.map(idLens).sort();
    const prevIds = prevJobs.map(idLens).sort();
    return !isEqual(nextIds, prevIds) || !isEqual(nextShowNudge, prevShowNudge);
  }

  render = () => {
    const { jobs = [], showNudge = false } = this.props;
    const nudgePosition = getIndexOfFirstNonPremium(jobs) + 1;

    const { isFirstJobClassic, isLastJobClassic } = getListDetails(jobs);

    const jobList = jobs.map((job, jobIndex) => (
      <JobListItem
        key={job.tracking}
        job={job}
        solMetadata={job.solMetadata}
        isFirst={jobIndex === 0}
        isLast={
          jobIndex === jobs.length - 1 ||
          (showNudge && jobIndex === nudgePosition - 1)
        }
      />
    ));

    if (showNudge) {
      jobList.splice(
        nudgePosition,
        0,
        <Nudge key="nudge" position={nudgePosition} />
      );
    }

    const rootClassName = classnames({
      [styles.root]: true,
      [styles.root_isFirstJobClassic]: isFirstJobClassic, // eslint-disable-line css-modules/no-undef-class
      [styles.root_isLastJobClassic]: isLastJobClassic // eslint-disable-line css-modules/no-undef-class
    });

    return <div className={rootClassName}>{jobList}</div>;
  };
}

export default SearchResultList;
